import employeeAfkComponent from './employeeAfk.component';
import employeeAfkService from './employeeAfk.service';

let employeeAfkModule = angular.module('vacations-absences.employeeAfk', [])

.component('employeeAfk', employeeAfkComponent)

.service('employeeAfkService', employeeAfkService)

.name;

export default employeeAfkModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeAfk/employeeAfk.js